export default "__VITE_ASSET__DdpC$M5q__"